import React from 'react';
import { InputGroup, FormControl } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons'; 

const SearchInput = ({ onInputChange }) => {

  const handleInputChange = (e) => {
    // Get the value from the input
    const inputValue = e.target.value;

    // Send the value to the parent component
    if (onInputChange) {
      onInputChange(inputValue);
    }
  };

  return (
    <InputGroup className="mb-1">
      <InputGroup.Text style={{ background: 'none', border: 'none', zIndex:'1' }}>
      <FontAwesomeIcon icon={faSearch} /> 
      </InputGroup.Text>
      <FormControl
        placeholder="Search.."
        id="dashbordinput1"
        style={{
          borderTop: '0px solid #aaa', 
          borderLeft: '0px solid #aaa', 
          borderRight: '0px solid #aaa', 
          borderBottom: '2px solid #aaa', // Adding a border at the bottom
          borderRadius: '0', // Optional: Remove border-radius
          paddingLeft: '30px',
          marginLeft: '-2.5em',
        }}
        onChange={handleInputChange}
      />
      
    </InputGroup>
  );
};

export default SearchInput;